import { render, staticRenderFns } from "./HeaderNavSection.vue?vue&type=template&id=32124fbe&scoped=true&"
import script from "./HeaderNavSection.vue?vue&type=script&lang=js&"
export * from "./HeaderNavSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32124fbe",
  null
  
)

export default component.exports